module.exports = __webpack_public_path__ + "img/00020.fbf4cb01.webp";